var _title, _defs, _g, _g2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSpaceship = function SvgSpaceship(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 250",
    "aria-labelledby": "title",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title"
  }, "spaceship")) : title ? /*#__PURE__*/React.createElement("title", {
    id: "title"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: 300,
    x2: 300,
    y1: 300,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e699a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4e699a",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e699a",
    stopOpacity: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stars"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 234.38,
    cy: 96.8,
    r: 1.13,
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,172.66a1.13,1.13,0,1,1-2.25,0,1.13,1.13,0,0,1,2.25,0Z",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.73,104.6a1.13,1.13,0,1,1-1.12-1.12A1.12,1.12,0,0,1,94.73,104.6Z",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,80.28a.56.56,0,1,1-1.12,0,.56.56,0,1,1,1.12,0Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.65,171.3a.56.56,0,1,1-.56-.57A.56.56,0,0,1,149.65,171.3Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.53,147.26a.56.56,0,1,1-1.12,0,.56.56,0,0,1,1.12,0Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,79.15a.56.56,0,1,1-.56-.56A.56.56,0,0,1,115,79.15Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.7,92.89a.57.57,0,1,1-1.13,0,.57.57,0,0,1,1.13,0Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.15,64.12a.56.56,0,0,1-.56.56.57.57,0,1,1,0-1.13A.56.56,0,0,1,206.15,64.12Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.45,132.26a1.13,1.13,0,1,1-1.13-1.13A1.13,1.13,0,0,1,294.45,132.26Z",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.64 145.21 99.11 146.8 100.69 147.26 99.11 147.73 98.64 149.31 98.18 147.73 96.59 147.26 98.18 146.8 98.64 145.21",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.13 106.61 279.59 108.2 281.18 108.66 279.59 109.13 279.13 110.71 278.66 109.13 277.07 108.66 278.66 108.2 279.13 106.61",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,76.75a1.85,1.85,0,1,1,0-3.69",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,199.13a1.91,1.91,0,1,1-1.91-1.85A1.88,1.88,0,0,1,335.72,199.13Z",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41,47.84a1,1,0,0,1,1.92,0",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.08,157.53a1,1,0,0,1,1.91,0",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,22.3a.92.92,0,1,1,0-1.84",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.72,123.16a1.91,1.91,0,0,1-3.82,0",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "374.2 93.56 374.99 90.97 375.78 93.56",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.84,77.78a2.46,2.46,0,1,1-2.45-2.24A2.36,2.36,0,0,1,35.84,77.78Z",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,204.05a1.22,1.22,0,1,1-1.22-1.12A1.18,1.18,0,0,1,124,204.05Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.87,27a1.23,1.23,0,1,1-1.23-1.13A1.18,1.18,0,0,1,79.87,27Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.54,54.39a1.23,1.23,0,1,1-1.23-1.12A1.19,1.19,0,0,1,144.54,54.39Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.62 158.88 43.23 160.83 45.35 161.4 43.23 161.96 42.62 163.91 42 161.96 39.88 161.4 42 160.83 42.62 158.88",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.93,215.21A1.92,1.92,0,1,1,57,213.36,1.88,1.88,0,0,1,58.93,215.21Z",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.19,
    cy: 139.68,
    r: 1.13,
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.53,214.71a1.17,1.17,0,0,1-1.65,1.65h0A1.17,1.17,0,0,1,216.53,214.71Z",
    fill: "#3f157a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.77,123.15a.56.56,0,1,1-1.12,0,.56.56,0,0,1,1.12,0Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,133.38a.57.57,0,1,1-.57-.56A.56.56,0,0,1,155.4,133.38Z",
    fill: "#eaf0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.32,213.82a1,1,0,0,1,1.92,0",
    fill: "#eaf0fb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ufo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "beam"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "174.05 147.02 144.37 239.3 240.33 239.3 209.11 147.02 174.05 147.02",
    opacity: 0.5,
    fill: "url(#gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.35,
    cy: 236.36,
    rx: 46.28,
    ry: 7.9,
    fill: "#b3fff9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "space-dust",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 202.91,
    cy: 176.14,
    r: 1.16,
    fill: "#fffdf0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.83,
    cy: 182.74,
    r: 1.16,
    fill: "#fffdf0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.4,
    cy: 158.68,
    r: 0.51,
    fill: "#8bd6ee"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.3,
    cy: 187.66,
    r: 0.51,
    fill: "#8bd6ee"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.24,
    cy: 168.23,
    r: 0.51,
    fill: "#fffdf0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.75,
    cy: 178.73,
    r: 0.51,
    fill: "#8bd6ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.91,193.45a.51.51,0,1,1-.51-.51A.51.51,0,0,1,178.91,193.45Z",
    fill: "#fffdf0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,161.54a.51.51,0,1,1-.51-.5A.51.51,0,0,1,178.4,161.54Z",
    fill: "#fffdf0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "person",
    d: "M199.83,215.5a1,1,0,0,0,0-2l-4.3.06a1,1,0,0,0-.74.34l-2.2,2.51a3.82,3.82,0,0,1-1.12-1.26l1.34-1.19a.79.79,0,0,0,.2-.31l1-2.8a.75.75,0,1,0-1.41-.5l-.94,2.61L190,214.46a.31.31,0,0,0-.07.09l-.12.09-.34-.54a2.06,2.06,0,0,0,.34-.85,2.22,2.22,0,1,0-2.58,1.81,2.19,2.19,0,0,0,1-.07l.3.48-2,2a.71.71,0,0,0-.21.4l-.52,2.88a.75.75,0,0,0,.61.87.77.77,0,0,0,.88-.61l.47-2.64.73-.73c.84,1,2.21,2.33,3.8,2.39l0,0h.09l4-.22,2.15,3.26a1,1,0,0,0,.67.44,1,1,0,0,0,.72-.15,1,1,0,0,0,.29-1.39l-2.46-3.75a1.06,1.06,0,0,0-.9-.45l-2.94.16,2.06-2.35Z",
    fill: "#252330"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ship"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bottomLight",
    d: "M150.29,137.43s15.13,13.36,41.91,13.36,44.74-13.63,44.74-13.63Z",
    fill: "#9fffed"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.36,
    cy: 131.04,
    rx: 48.98,
    ry: 13.39,
    fill: "#3edbcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.68,128.06h0a6.71,6.71,0,0,0-1.41-1.49c-9.94-10-23.15-13.54-23.15-13.54H171.25c-16.28,4.9-23.46,13.36-24.45,14.61l0,0a.52.52,0,0,0-.09.12,3.64,3.64,0,0,0-.85,2.22c0,6.49,21.16,11.75,47.25,11.75s47.25-5.26,47.25-11.75A3.48,3.48,0,0,0,239.68,128.06Z",
    fill: "#5f6798"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lights"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.22,
    cy: 129.09,
    rx: 4.16,
    ry: 2.95,
    fill: "#88ffe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.79,126.62c.38,1.25-1,2.79-3.17,3.42s-4.15.14-4.52-1.12,1-2.79,3.16-3.42S174.42,125.36,174.79,126.62Z",
    fill: "#88ffe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.68,122.36c.43.74-.55,2.12-2.2,3.07s-3.33,1.11-3.76.37.56-2.12,2.2-3.07S160.25,121.61,160.68,122.36Z",
    fill: "#88ffe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.63,122.36c-.43.74.55,2.12,2.2,3.07s3.33,1.11,3.76.37-.56-2.12-2.2-3.07S226.06,121.61,225.63,122.36Z",
    fill: "#88ffe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6,126.62c-.37,1.25,1,2.79,3.17,3.42s4.15.14,4.53-1.12-1.05-2.79-3.17-3.42S212,125.36,211.6,126.62Z",
    fill: "#88ffe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.65,121.44a4.91,4.91,0,0,1,2.21-2.39,5,5,0,0,1,2.84-.79Z",
    fill: "#88ffe8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.7,121.79a5.67,5.67,0,0,0-5.06-3.17Z",
    fill: "#88ffe8"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.36,
    cy: 113.03,
    rx: 21.93,
    ry: 4.28,
    fill: "#cf7ddb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.55,113.39a.66.66,0,0,0,.37-.71c-1.6-8.51-10.19-15-20.56-15s-19,6.51-20.56,15a.65.65,0,0,0,.3.68c1.21.74,5.78,2.71,20.26,2.71C206,116.08,211.42,114.39,213.55,113.39Z",
    fill: "#3edbcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.88,97.4V88.57a1.56,1.56,0,0,0,1.06-1.48,1.58,1.58,0,1,0-3.16,0,1.56,1.56,0,0,0,1.05,1.48V97.4c-2,0-3.63.26-3.63.54s1.86.53,4.16.53,4.16-.24,4.16-.53S195.93,97.44,193.88,97.4Z",
    fill: "#5f6798"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpaceship, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spaceship.1b0e9571.svg";
export { ForwardRef as ReactComponent };